import { $api } from '@/shared/api/axiosInstance';
import { User } from '../model/types/userTypes';

type RequestProps = {
    id: string;
};

export const authQuery = async ({ id }: RequestProps) => {
    const url = `/api/v1/users/${id}`;

    const data = await $api.get<User>(url);

    return data;
};
